import axios from 'axios';
import { getToken, EliminarTodo } from './LocalStorage';

export function url() {
    //return 'http://52.117.24.189:8106/api/'
    //return 'https://localhost:44397/api/'
    //console.log('Entorno');
    //console.log(process.env);    
    return process.env.REACT_APP_URL_SERVICIO; //'https://www.unifact.uniflex.com.pe/Unifact.EmisionAPI/api/'
}

export async function initAxiosInterceptors(){
    axios.interceptors.request.use(
        function(config){
            const token = getToken();
            if(token){
                config.headers.Authorization = `Bearer ${token}`;
            }
            return config;
        },
        function(error){
            return Promise.reject(error);
        }
    )
    axios.interceptors.response.use(
        function(response){
            return response;
        },
        async function (error){
            const originalRequest = error.config;
            if (error.response.status === 401 && !originalRequest._retry) {
                originalRequest._retry = true;
                if(getToken()){
                    alert("Debe iniciar sesión nuevamente.")
                    EliminarTodo();
                    window.location.reload(true);
                }
            }
            return Promise.reject(error);
        }
    )
}
